import { Column } from '@melements/front-components/dist/components/list/table/Table.types';

import { UnlockButtonContainer } from './unlockButton/UnlockButtonContainer';

// tslint:disable-next-line:prefer-array-literal
const COLUMNS_ARRAY: Array<Column<any>> = [
  {
    key: 'endpoint',
    name: { id: 'ENDPOINTS.TABLE.COLUMNS.ENDPOINT' },
  },
  {
    key: 'bankId',
    name: { id: 'ENDPOINTS.TABLE.COLUMNS.BANK_ID' },
  },
  {
    key: 'startDateTime',
    name: { id: 'ENDPOINTS.TABLE.COLUMNS.START_DATE_TIME' },
  },
  {
    key: 'endDateTime',
    name: { id: 'ENDPOINTS.TABLE.COLUMNS.END_DATE_TIME' },
  },
  {
    component: UnlockButtonContainer,
    key: 'action',
    name: { id: 'ENDPOINTS.TABLE.COLUMNS.ACTION' },
  },
];

export const COLUMNS = [COLUMNS_ARRAY];
